import { useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';

export default ({
  url,
  onClose = () => {},
  options = { transports: ['websocket'], reconnectionAttempts: 2 },
}) => {
  const socketRef = useRef();
  const [isLoading, setIsLoading] = useState(true);

  const closeSocket = () => {
    onClose(socketRef.current);
    if (socketRef.current) socketRef.current.disconnect();
  };

  useEffect(() => {
    if (url && options) {
      const socket = io(url, { ...options });
      socket.on('error', () => {
        setIsLoading(false);
      });
      socket.on('connect', () => {
        setIsLoading(false);
      });
      socket.on('reconnect_failed', () => {
        setIsLoading(false);
      });
      socket.on('disconnect', () => {
        closeSocket();
      });
      socketRef.current = socket;
    }

    // window.addEventListener('beforeunload', closeSocket);
    // window.addEventListener('unload', closeSocket);

    const interval = window.setInterval(() => {
      setIsLoading(false);
    }, 10000);

    return () => {
      window.clearInterval(interval);
      // window.removeEventListener('beforeunload', closeSocket);
      // window.removeEventListener('unload', closeSocket);
      closeSocket();
    };
  }, []);

  return { socket: socketRef.current || null, isLoading };
};
